import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux-store";
import Button from "../../components/Button";
import {
  selectGenerateKeyRequestInProgress,
  selectWebBookingApiKeyExists,
  selectWebBookingApiKeyValue,
} from "../../ducks/app/web-booking-api-access/selectors";
import {
  generateKey,
  hideKey,
  loadHasKey,
} from "../../ducks/app/web-booking-api-access";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";

const WebBookingApiKeySettings = () => {
  const { t } = useTranslation("apiIntegration");
  const hasApiKey = useSelector(selectWebBookingApiKeyExists);
  const apiKeyValue = useSelector(selectWebBookingApiKeyValue);
  const generateKeyRequestInProgress = useSelector(
    selectGenerateKeyRequestInProgress
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadHasKey());
  }, [dispatch]);

  const onGenerateKeyClick = async () => {
    await dispatch(generateKey());
  };

  const onKeyDialogCloseClick = () => {
    dispatch(hideKey());
  };

  return (
    <div>
      {apiKeyValue ? (
        <Dialog open>
          <DialogTitle>{t("newKeyDialog.title")}</DialogTitle>
          <DialogContent>
            <div>{t("newKeyDialog.text")}</div>
            <div className="mt-6 font-bold">{apiKeyValue}</div>
          </DialogContent>
          <DialogActions>
            <Button variant="primary" onClick={onKeyDialogCloseClick}>
              {t("newKeyDialog.closeButton")}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
      <div>{t("title")}</div>
      <div className="mt-2">
        {hasApiKey ? (
          <div>
            <div>{t("apiKeyExists")}</div>
          </div>
        ) : (
          <div>{t("noApiKey")}</div>
        )}
        <div className="mt-2">
          <Button
            variant="primary"
            onClick={onGenerateKeyClick}
            disabled={generateKeyRequestInProgress}
          >
            {generateKeyRequestInProgress
              ? t("generateApiKeyPending")
              : t("generateApiKey")}
          </Button>
        </div>
        <div className="mt-4">
          {t("viewDocumentation")}:{" "}
          <a
            href="https://web-booking-api.doranordic.dk"
            rel="noreferrer"
            target="_blank"
          >
            https://web-booking-api.doranordic.dk
          </a>
        </div>
      </div>
    </div>
  );
};

export default WebBookingApiKeySettings;
